import React, { ChangeEvent } from 'react';

export interface Props {
  disabled?: boolean;
  expandOnDesktop?: boolean;
  name?: string;
  selected: boolean;
  subtext?: string;
  text: string;
  toggleSelected(e: ChangeEvent<HTMLInputElement>): void;
}

export const CheckboxListItem = ({
  disabled = false,
  expandOnDesktop,
  name,
  selected,
  subtext,
  text,
  toggleSelected,
}: Props): JSX.Element => (
  <label
    className={`${selected ? 'bg-sapphire' : 'bg-neutral-200'} relative block ${
      !expandOnDesktop ? 'lg:inline-block' : ''
    } rounded-full max-w-xs px-3 se:px-4 py-2 mb-3 cursor-pointer select-none transition-all`}
  >
    <input
      type='checkbox'
      className='reverse peer mt-0 rounded-sm align-middle border-2 border-almostBlack checked:border-white bg-neutral-200 checked:text-white checked:bg-current focus:ring-0 focus:ring-offset-0 focus:outline-none'
      checked={selected}
      disabled={disabled}
      name={name}
      onChange={toggleSelected}
    />
    <span className='ml-2 mt-0.5 align-middle inline-block font-semibold lg:text-sm text-almostBlack peer-checked:text-white'>
      {text}
      {subtext && (
        <span
          className={`text-sm lg:text-xs ${
            !expandOnDesktop
              ? 'lg:absolute lg:top-11 lg:text-almostBlack lg:font-normal lg:left-0 lg:right-0 lg:text-center'
              : ''
          }`}
        >
          {' '}
          {subtext}
        </span>
      )}
    </span>
  </label>
);
